import { render, staticRenderFns } from "./quotedPriceCoefficientExtract.vue?vue&type=template&id=7951fda3&scoped=true"
import script from "./quotedPriceCoefficientExtract.vue?vue&type=script&lang=js"
export * from "./quotedPriceCoefficientExtract.vue?vue&type=script&lang=js"
import style0 from "./quotedPriceCoefficientExtract.vue?vue&type=style&index=0&id=7951fda3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951fda3",
  null
  
)

export default component.exports